// @flow

import _ from 'lodash';

import ko from 'rgs-knockout';
import kv from 'knockout.validation';

/* eslint-disable max-len */
kv.rules.email.validator = function (val) {
	return kv.utils.isEmptyVal(val) || (
		// jquery validate regex with unicode support removed
		/^((([a-z]|\d|[#\$%&'\+\-=\^_`{\|}~])+(\.([a-z]|\d|[#\$%&'\+\-=\^_`{\|}~])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d)|(([a-z]|\d)([a-z]|\d|-|\.|_|~)*([a-z]|\d)))\.)+(([a-z])|(([a-z])([a-z]|\d|-|\.|_|~)*([a-z])))$/i.test(val)
	);
};
/* eslint-enable max-len */

// Support for arrays as messages
const formatMessage = kv.formatMessage;
kv.formatMessage = function (message, params, observable) {
	if (_.isArray(message)) {
		return _.map(message, function (msg) {
			return formatMessage.call(this, msg, params, observable);
		});
	}
	if ('object' === typeof message) {
		return message;
	}
	return formatMessage.apply(this, arguments);
};

require('./js/localize');
require('./js/util');
require('./js/extenders');
if (typeof window !== 'undefined') {
	require('./js/bindings');
}
require('./js/auto-message-placement');

ko.validation.init({
	validate: {
		setModifiedOnChange: false,
	},
	insertMessages: false,
	decorateInputElement: false,
	errorsAsTitle: false,
}, true);

export default kv;
export { ValidationError } from './js/group';
export type { ValidationGroupInterface } from './js/group';
